/**
 * Labels the API sends as raw keys, made readable — one rule for every widget,
 * chip and table.
 *
 * deepdive-v2 names many topics, intents and industries by their database key
 * (`digital_banking`). Those become words with capitals (`Digital Banking`). A
 * label already written for people — any capital in it, no underscore
 * (`Customer service`, `iPhone`, `MyGP`) — is left exactly as it is, and so is
 * anything that looks like an id rather than a name.
 */

/** A UUID, or a bare number — an id standing in for a missing name. */
const ID_LIKE = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}|\d+)$/i;

export function readableLabel(label: string): string {
  const trimmed = label.trim();
  if (!trimmed || ID_LIKE.test(trimmed)) return trimmed;
  const isRawKey = trimmed.includes('_') || trimmed === trimmed.toLowerCase();
  if (!isRawKey) return trimmed;
  return trimmed
    .split(/[_\s]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

/**
 * The form two spellings of one name share — `digital_banking`,
 * `Digital Banking` and `digital banking` all match. For matching API names
 * against labels that have been through `readableLabel`.
 */
export function labelMatchKey(label: string): string {
  return label
    .trim()
    .toLowerCase()
    .replace(/[_\s]+/g, ' ');
}
